<template>
	<div style="width: 80vw !important">
		<loading-overlay
			:active="isLoaded"
			:can-cancel="true"
		/>
		<b-modal
			id="bulkDiscount-modal"
			ref="addBulkDiscount-modal"
			hide-footer
		>
			<template #modal-title>
				Create New Bulk Discount
			</template>
			<div class="d-block text-center">
				<b-form-group
					class="form-group"
					label="Name: "
					label-for="block-form1-name"
				>
					<Field
						v-slot="{ errors }"
						v-model="name"
						rules="required"
						name="name"
					>
						<div
							class="control"
						>
							<b-form-input
								v-model="name"
								type="text"
							/>
							<span>{{ errors[0] }}</span>
						</div>
					</Field>
				</b-form-group>
			</div>
			<b-button
				class="mt-3"
				block
				@click="addBulkDiscount()"
			>
				Save
			</b-button>
		</b-modal>
		<base-block
			title="Existing Bulk Discounts"
			header-bg
		>
			<div
				ref="BulkDiscountTable"
			/>
		</base-block>
	</div>
</template>
